import Vue from 'vue';
import * as Pinia from 'pinia';

Vue.use(Pinia.PiniaVuePlugin);

export default Pinia.createPinia();
